class WidgetAEX {
	init() {
		const self = this;
		if (jQuery('.widget.ll-aex').length !== 0) {
			setInterval(function () {
				self.refresh();
			}, 30000);
			self.refresh();
		}
	}

	refresh() {
		jQuery.getJSON('/wp-json/bi/v1/aex/', function (data) {
			if (data) {
				jQuery('.widget.ll-aex .ll-aex-absolute').html(
					data.Quotes.IndexQuote.Quote,
				);
				if (data.Quotes.IndexQuote.ChangePercent > 0) {
					jQuery('.widget.ll-aex .ll-aex-wrapper').addClass('ll-aex-positive');
					jQuery('.widget.ll-aex .ll-aex-wrapper').removeClass(
						'll-aex-negative',
					);
				} else if (data.Quotes.IndexQuote.ChangePercent < 0) {
					jQuery('.widget.ll-aex .ll-aex-wrapper').addClass('ll-aex-negative');
					jQuery('.widget.ll-aex .ll-aex-wrapper').removeClass(
						'll-aex-positive',
					);
				} else {
					jQuery('.widget.ll-aex .ll-aex-wrapper').removeClass(
						'll-aex-negative',
					);
					jQuery('.widget.ll-aex .ll-aex-wrapper').removeClass(
						'll-aex-positive',
					);
				}

				jQuery('.widget.ll-aex .ll-aex-change-percentage').html(
					data.Quotes.IndexQuote.ChangePercent + '%',
				);
				jQuery('.widget.ll-aex .ll-aex-link').attr(
					'href',
					data.Quotes.IndexQuote.Url,
				);
				jQuery('.widget.ll-aex .ll-aex-title').html(
					data.Quotes.IndexQuote.Name,
				);
			}
		});
	}
}

const instance = new WidgetAEX();
export default instance;
